import { ChangeDetectionStrategy, Component, OnChanges, SimpleChanges, inject, input, model, output } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';

import { CanDirective } from '@/core/permissions/can.directive';
import { PERMISSOES } from '@/core/permissions/permissoes.catalog';
import { PessoaAvatarComponent } from '@/shared/components/pessoa/pessoa-avatar/pessoa-avatar';

import { DialogoPadraoDirective } from '@/shared/components/layout/dialogo-padrao/dialogo-padrao.directive';
/** Opção de seleção de gestor (rótulo + chave `id|uf`). */
export interface OpcaoGestorAta {
    label: string;
    value: string;
}

/** Chaves selecionadas dos gestores da reunião. */
export interface GestoresChavesAta {
    coordenador: string;
    secretario: string;
    assistente: string;
}

/** Diálogo de designação de gestores (coordenador/secretário/assistente) da reunião. */
@Component({
    selector: 'app-ata-dialog-gestores',
    standalone: true,
    imports: [DialogoPadraoDirective, ReactiveFormsModule, ButtonModule, DialogModule, SelectModule, CanDirective, PessoaAvatarComponent],
    templateUrl: './ata-dialog-gestores.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AtaDialogGestoresComponent implements OnChanges {
    private readonly formBuilder = inject(FormBuilder);

    /** Visibilidade do diálogo (two-way). */
    readonly visivel = model(false);
    /** Opções de membros para coordenador/secretário. */
    readonly opcoesMembros = input<OpcaoGestorAta[]>([]);
    /** Opções de assistente. */
    readonly opcoesAssistentes = input<OpcaoGestorAta[]>([]);
    /** Chaves iniciais (semeia o formulário ao abrir). */
    readonly inicial = input<GestoresChavesAta>({ coordenador: '', secretario: '', assistente: '' });
    /** Emite as chaves confirmadas. */
    readonly confirmar = output<GestoresChavesAta>();

    protected readonly roleGerenciarConvidados = PERMISSOES.comissoes.atas.gerenciarConvidados;
    protected readonly formulario = this.formBuilder.nonNullable.group({
        coordenador: '',
        secretario: '',
        assistente: ''
    });

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['visivel'] && this.visivel()) {
            this.formulario.patchValue(this.inicial(), { emitEvent: false });
        }
    }

    /** Extrai o id da pessoa de uma chave "id|uf" (para a foto do avatar); null se ausente. */
    protected idDaChavePessoa(chave: string | null | undefined): number | null {
        const id = Number((chave ?? '').split('|')[0]);
        return Number.isFinite(id) && id > 0 ? id : null;
    }

    /** Extrai a UF de uma chave "id|uf". */
    protected ufDaChavePessoa(chave: string | null | undefined): string {
        return (chave ?? '').split('|')[1] ?? '';
    }

    protected fechar(): void {
        this.visivel.set(false);
    }

    protected aoConfirmar(): void {
        this.confirmar.emit(this.formulario.getRawValue());
        this.fechar();
    }
}
